export enum QuestionType {
  Ok = 1,
  Nok,
  NotRelevant,
  Unknown,
}
